import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const Filter2CodeIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-filter2-code${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2.66666 4H13.3333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 8H12"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12H7.33333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 11.3333L10 12.6667L11.3333 14"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 14L14.6667 12.6667L13.3333 11.3333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default Filter2CodeIcon;
